import { Drawer, Tabs } from 'antd'
import styled, { keyframes } from 'styled-components'

const animateDraggedRow = keyframes`
  0% {
    background: transparent;
    box-shadow: none;
  }
  50% {
    background: #f0f3ff;
  }
  100% {
    background: transparent;
    box-shadow: none;
  }
`

export const MenuExtra = styled.div`
  .ant-divider {
    margin: 0 0 4px 0;
  }

  .enterItem {
    margin: 8px;
  }
`

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header,
  .ant-drawer-wrapper-body {
    background: #fdfdfd;
    overflow: hidden;
  }

  .ant-drawer-header {
    min-height: 55px;

    .ant-btn-link {
      height: auto;
      line-height: 1 !important;
      padding: 0;
    }
  }

  .ant-select:not(.ant-select-auto-complete) .ant-select-selector {
    background: #ffffff;
  }

  &:not(.ant-drawer-open) .ant-drawer-wrapper-body {
    position: relative;
  }

  &.childDrawer .ant-drawer-body {
    padding: 15px 15px 70px;
  }

  .search-patient-container {
    > .ant-form-item {
      flex: 1;
      .ant-row {
        width: 100% !important;
      }
    }

    .ant-switch {
      margin: 5px 10px 0;
    }
  }

  .ant-input-group-wrapper:not(.question-input) .ant-input-group-addon {
    padding: 0;
    border: 0;
    box-shadow: none;
  }

  .note {
    margin-bottom: 0.2rem;
  }

  .patientContainer {
    padding: 1rem 1rem 0;
    border-radius: 8px;
    margin-bottom: 2.5rem;
    box-shadow: 0 0 6px var(--patient-box-shadow);
    background: rgba(0, 99, 193, 0.03);

    .title {
      margin-bottom: 1rem;
      display: block;
    }
  }

  .ant-drawer-body {
    padding-top: 0;
    padding-bottom: 120px;
  }

  form {
    position: relative;
    padding-top: 1rem;
  }

  .form-chart-header {
    margin: 1rem 0;

    .ant-select {
      min-width: 150px;
    }

    .ant-form-item {
      margin: 0;
    }
  }

  .ant-space-item .ant-form-item {
    margin: 0;
  }

  .space-search {
    display: flex;
    > .ant-space-item:first-of-type {
      flex: 1;
    }
  }

  .ant-drawer-wrapper-body {
    max-width: 100%;
    @media all and (max-width: 992px) {
      min-width: 90%;
      .ant-drawer-header {
        padding: 8px;
      }
    }
  }

  &.has-custom-footer {
    padding-bottom: 60px;
    .ant-spin-container,
    .ant-spin-nested-loading {
      position: static;
    }
  }

  .custom-drawer-footer {
    position: absolute;
    bottom: 0;
    flex-shrink: 0;
    padding: 8px 16px;
    border-top: 1px solid rgba(5, 5, 5, 0.06);
    left: 0;
    right: 0;
    z-index: 10;
    background: white;
  }
`

export const TableContainer = styled.div`
  background: var(--main-background);

  .hidden-item {
    display: none;
  }
`

export const StyledTable = styled.div`
  table {
    background: #ffffff;

    .ant-table-row {
      cursor: ${props => props.cursor || 'pointer'};

      .ant-select-arrow {
        opacity: 0.2;
      }

      .ant-select .anticon-close-circle {
        font-size: 13px;
      }

      &.highlighted td {
        background: #f0f3ff;
      }

      &:hover .hiddenIcon button,
      &:hover .hiddenIcon span,
      &:hover .ant-select-arrow,
      &.deleting .hiddenIcon button,
      &.deleting .hiddenIcon span {
        opacity: 1;
      }
    }

    .ant-table-cell {
      white-space: break-spaces;
    }

    td {
      max-width: 300px;
      min-width: 50px;
      word-break: break-word;

      .ant-tag {
        margin: 4px;
        white-space: inherit;
        max-width: 100%;
      }

      > .anticon-check-circle,
      > .anticon-close-circle,
      > .ant-space .anticon-check-circle:not(.small-icon),
      > .ant-space .anticon-close-circle:not(.small-icon) {
        font-size: 21px;
      }

      .small-icon {
        font-size: 14px;
      }

      .anticon-play-circle,
      .anticon-pause-circle {
        font-size: 18px;
      }
    }

    .ant-input-number-wrapper .ant-input-number-group-addon {
      border: 0;
    }
  }

  .no-body .ant-table-tbody {
    display: none;
  }
  .ant-space-vertical .ant-typography {
    margin-bottom: 0;
  }

  &.for-chart {
    .ant-table-selection-column {
      text-align: start;
      margin-left: 5px;
      margin-right: 5px;
    }

    .ant-space-item a {
      color: var(--ant-primary-color);
      .ant-typography-ellipsis {
        margin: 0;
        color: inherit;
        max-width: 250px;
      }
    }
  }

  &.scroll-fix .ant-table-content {
    overflow-x: scroll;

    table {
      width: max-content;
      min-width: 100%;
    }
  }

  .phone-number-text {
    margin: 0;
  }

  &.operations-table .ant-table-container {
    overflow-x: scroll;
    max-width: 75vw;

    table {
      width: max-content;
      min-width: 100%;
    }
  }

  .ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
    margin: 0;
  }

  .ant-table.ant-table-middle .ant-table-tbody > tr.ant-table-expanded-row > td {
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    padding: 0.5rem;
  }

  .ant-table-row.highlight > td:first-of-type {
    border-left: 2px solid #ff4d4f;
  }

  .ant-table-rtl .ant-table-row.highlight > td:first-of-type {
    border-right: 2px solid #ff4d4f;
    border-left: 0;
  }

  &:not(.show-pagination) .ant-pagination {
    display: none;
  }

  .tableActionCol {
    width: 60px;
  }

  .newRow td {
    animation: ${animateDraggedRow} 1.5s linear 1;
  }

  .ant-form-explain {
    display: none;
  }

  .fs18,
  .fs18 button {
    font-size: 18px;
    line-height: 18px;
  }

  .ant-avatar-group > div:not(:first-child) {
    margin-left: -8px;

    .ant-avatar {
      border: 0;
    }
  }

  .ant-table-title {
    .end-title {
      display: flex;
      justify-content: flex-end;
      font-size: 20px;
      flex-wrap: wrap;

      &.space-between {
        justify-content: space-between;
      }
    }
  }

  .table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &:not(.invoice-drawer) .ant-table-summary {
    background: #98dbed54;
  }

  @media screen and (min-width: 992px) {
    .hiddenIcon button,
    .hiddenIcon span:not(.ant-typography) {
      opacity: 0;
      transition: opacity 0.3s ease-in;

      &:focus,
      &.active,
      &:focus span,
      &.active span {
        opacity: 1;
      }
    }
  }
  @media screen and (max-width: 576px) {
    &.scroll-fix .ant-table-content,
    .ant-table-content {
      table {
        width: initial;
        min-width: 100%;

        td {
          word-break: initial;
        }
      }
    }
  }
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.2rem;
  flex-flow: row wrap;

  input,
  .ant-select-selector {
    background: #ffffff;
  }

  .ant-select {
    width: 170px;
    &.ant-select-auto-complete {
      width: 220px;
    }
    max-width: 90vw;
  }

  .ant-picker {
    border-radius: 0;
    box-shadow: none;

    &:not(.ant-picker-range) {
      width: 160px;
    }
    &.ant-picker-range {
      min-width: 250px;
      max-width: 60vw;
    }
  }

  &.flex-end {
    justify-content: flex-end;
  }

  .select-rows {
    width: 120px;
  }

  .table-search .ant-input-search-button {
    padding: 0;
    > span {
      padding: 4px 15px;
    }
  }

  input:not(:hover):not(:focus),
  .ant-input-affix-wrapper,
  .ant-select-selector:not(:hover):not(:focus),
  .ant-picker:not(:hover):not(:focus) {
    border-color: #ffffff;
  }

  .ant-select-selector:hover,
  .ant-select-selector:focus {
    border-color: var(--ant-primary-color) !important;
  }

  .ant-select-focused {
    input,
    .ant-select-selector {
      border-color: var(--ant-primary-color) !important;
    }
  }

  .ant-select-selection {
    border: none;

    .ant-tag {
      margin: 0 7px 0 3px;
      line-height: 18px;
      height: 21px;
      padding: 1px 20px;
    }
  }

  .inputsContainer {
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    flex: 1;
    align-items: center;

    > div,
    > span {
      margin: 3px 5px 3px 0;
    }

    .ant-btn:not(:hover):not(:focus) {
      border-color: #ffffff;
    }
  }

  .subHeader {
    flex-grow: 1;
    display: flex;
    flex-flow: row wrap;

    > div {
      &:nth-of-type(2) {
        flex: 1 0 250px;
        max-width: 100%;
        margin: 0 10px;
      }
    }

    input {
      margin: 10px 0;
    }
  }

  .color-tag {
    cursor: pointer;
  }

  @media screen and (max-width: 576px) {
    padding: 1rem 5px;
    .ant-select,
    .ant-picker {
      width: 200px;
      &.ant-picker-range {
        min-width: auto;
      }
    }
  }
`

export const TableFooter = styled.div`
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  flex-flow: row wrap;
  background: #ffffff;

  .ant-btn-group-rtl {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  @media screen and (max-width: 992px) {
    padding: 1rem 0.4rem;
    margin: 0 -5px;
  }
`

export const StyledTabs = styled(Tabs)`
  background: #ffffff;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.05);
  border-radius: 3px;

  .ant-tabs-top-bar {
    border-bottom: none;
    padding-top: 5px;
  }

  .ant-tabs-nav-wrap {
    text-align: center;
  }

  &.no-margin .ant-tabs-nav {
    margin-bottom: 0;
  }

  &.ant-tabs-small .ant-tabs-nav .ant-tabs-tab {
    padding: 5px 13px;

    .ant-tag {
      font-size: 7px;
      line-height: normal;
      padding: 2px;
      margin-right: 0;
    }
  }

  .default-background {
    background: var(--main-background);
  }

  &.notifications-menu {
    width: 1000px;
    max-width: 90vw;
  }

  .ant-tabs-nav {
    > div {
      display: flex;

      > div {
        display: flex;
      }
    }

    .ant-tabs-ink-bar {
      display: none !important;
    }

    .ant-tabs-tab {
      padding: 9px 15px;
      margin: 0;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      border-bottom: 3px solid #ffffff;
      position: relative;

      .hiddenIcon {
        opacity: 0;
        position: absolute;
        top: 2px;
        margin: 0;
        transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:first-of-type {
          left: 2px;
          cursor: move;
        }

        &:last-of-type {
          right: 2px;
        }
      }

      .ant-tag {
        font-size: 9px;
        line-height: normal;
        padding: 2px 4px;
        margin-right: 0;
      }

      input {
        height: 25px;
        width: 150px;
      }

      .ant-form-item {
        margin-bottom: 0;
      }

      .ant-form-item-control {
        line-height: 25px;
      }

      &.ant-tabs-tab-active,
      &:hover {
        background: var(--ant-primary-2);
        border-bottom-color: var(--ant-primary-color);
      }

      &:hover {
        .hiddenIcon {
          opacity: 1;
        }
      }
    }
  }

  .ant-btn-link:not(.ant-btn-dangerous) {
    color: var(--ant-primary-color);
  }

  .ant-form-item-explain {
    display: none;
  }

  .ant-tabs-extra-content {
    height: 42px;
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  td > div .amount-price-field.ant-input-number:not(:focus) {
    border-color: #ffffff;
  }

  .amount-price-field .ant-input-number-group-addon {
    background: inherit;
  }

  .amount-price-field {
    min-width: 80px;
    &.with-min-width {
      min-width: 120px;
    }
    &.small {
      max-width: 100px;
    }
  }

  .ant-table-row {
    .ant-form-item {
      border-style: hidden;
      margin-bottom: 0;
    }

    .ant-form-item:not(.ant-form-item-has-error) {
      input:not(:focus),
      .ant-input-number:not(:focus),
      .ant-select-selector:not(:focus) {
        border-color: #ffffff;
      }
    }

    .ant-select-selector:not(:hover):not(:focus) {
      border-color: #ffffff;
    }

    .ant-form-item-has-error {
      .ant-select-selector {
        border-color: var(--ant-error-color);
      }

      .ant-select-focused .ant-select-selector {
        box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
      }
    }

    .ant-select-selector {
      background: #ffffff;
    }

    &[draggable='true'] {
      cursor: move !important;
    }
  }

  .ant-table-tbody > tr > td.ant-table-column-sort {
    background: transparent;
  }

  .ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters::before {
    display: none;
  }

  .ant-table-thead > tr > th.ant-table-column-sort {
    background: #fafafa;
  }

  .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {
    cursor: inherit;
  }

  .drop-over-downward td {
    border-bottom: 2px dashed var(--ant-primary-color);
  }

  .drop-over-upward td {
    border-top: 2px dashed var(--ant-primary-color);
  }

  .drop-over-right {
    border-right: 2px dashed var(--ant-primary-color);
  }

  .drop-over-left {
    border-left: 2px dashed var(--ant-primary-color);
  }

  tr.dragged td,
  div.dragged {
    animation: ${animateDraggedRow} 1s cubic-bezier(0.645, 0.045, 0.355, 1) 1;
  }

  @media screen and (max-width: 500px) {
    .wrap-on-small {
      flex-wrap: wrap;
    }
  }
`

export const ImagePreviewContainer = styled.div`
  position: relative;
  display: inline-block;

  &.with-margin {
    margin: 1rem;
  }

  &.pointer {
    cursor: pointer;
  }

  &.multiple .overlay-img {
    border-radius: ${props => props.size}px;
  }

  .overlay-img {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s ease;

    .anticon {
      color: #ffffff;
    }
  }

  &:hover .overlay-img {
    opacity: 1;
  }
`
